import Button from "@mui/material/Button"
import { FormControlLabel, Grid2 as Grid, Switch } from "@mui/material"
import { Formik, Field } from "formik"
import { Fondo } from "../../types"
import { useMemo, useState } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormikTextField, FormikSelectVocabolario } from "./formsHelpers"
import { ACProduttore, ACDonatore, ACEnte, ACLuogoMulti, ACVocabolarioMulti } from "./autocompletes"
import { FormInDialogProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import { useCalcolasegnaturaFondo } from "../../hooks/fondi"
import DonatoreForm from "./DonatoreForm"
import { useDonatoreCreate } from "../../hooks/donatori"
import EnteForm from "./EnteForm"
import { useEnteCreate } from "../../hooks/enti"
import ProduttoreForm from "./ProduttoreForm"
import { useProduttoreCreate } from "../../hooks/produttori"
import { FondiCollegatiField } from "./FondiCollegatiField"
import LuogoForm from "./LuogoForm"
import { useLuogoCreate } from "../../hooks/luoghi"

export default function FondoForm({ item, save, ref, language }: FormInDialogProps<Fondo>) {
  const { t } = useTranslation()

  const [currentProduttore, setCurrentProduttore] = useState<number | undefined>(item?.produttore)
  const [currentPrefisso, setCurrentPrefisso] = useState<string>(item?.prefisso_segnatura || "HM")
  const { data: segnaturaCalcolata } = useCalcolasegnaturaFondo(currentProduttore, item?.id, currentPrefisso)

  const { mutateAsync: createDonatore } = useDonatoreCreate()
  const { mutateAsync: createEnte } = useEnteCreate()
  const { mutateAsync: createLuogo } = useLuogoCreate()
  const { mutateAsync: createProduttore } = useProduttoreCreate()

  const schema = useMemo(
    () =>
      yup.object().shape({
        denominazione: yup.string().required().label(t("fondo.denominazione")),
        produttore: yup.number().required().label(t("fondo.produttore")),
        prefisso_segnatura: yup.string().required().label(t("fondo.prefisso_segnatura")).max(2).min(2),
      }),
    [t]
  )

  const segnaturaUi = useMemo(() => {
    return segnaturaCalcolata || ""
  }, [segnaturaCalcolata, item])

  const initialValues = useMemo(() => {
    return (
      item ?? {
        denominazione: "",
        tipologia: "",
        donatore: "",
        produttore: undefined,
        conservatore_originale: undefined,
        conservatore_digitale: undefined,
        genere: [],
        prefisso_segnatura: "HM",
        segnatura: "",
        provenienza: undefined,
        collocazione: "",
        collocazione_temporanea: "",
        cronologia_da: "",
        cronologia_a: "",
        cronologia_note_it: "",
        cronologia_note_en: "",
        tipo_supporto: undefined,
        tipi_supporto: [],
        notifica: false,
        luoghi_provenienza: [],
      }
    )
  }, [item])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        const submitValues = { ...values, segnatura: segnaturaCalcolata }
        return save(submitValues as Fondo).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue, setFieldTouched, errors, touched, submitCount }) => {
        console.log(123, errors)
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  name="denominazione"
                  label={t("fondo.denominazione")}
                  autoFocus
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid size={6}>
                <Field
                  name="tipologia"
                  label={t("fondo.tipologia")}
                  component={FormikSelectVocabolario}
                  vocabolario="fondo_tipo"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              {/* <Grid size={12}>
                <ACVocabolarioMulti
                  label={t("fondo.genere")}
                  vocabolario="fondo_genere"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.genere as number[]}
                  onChange={(value) => {
                    setFieldValue("genere", value)
                  }}
                  onBlur={() => {
                    setFieldTouched("genere", true)
                  }}
                />
              </Grid> */}
              <Grid size={6}>
                <ACProduttore
                  label={t("fondo.produttore")}
                  error={errors.produttore}
                  required
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.produttore}
                  onChange={(value) => {
                    setFieldValue("produttore", value)
                    setCurrentProduttore(value ?? undefined)
                  }}
                  onBlur={() => {
                    setFieldTouched("produttore", true)
                  }}
                  touched={touched.produttore}
                  submitCount={submitCount}
                  FormComponent={ProduttoreForm}
                  create={createProduttore}
                  initialCreate={(search) => ({ cognome: search })}
                />
              </Grid>
              <Grid size={2}>
                <Field
                  component={FormikTextField}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    console.log("123", e.target.value)
                    setFieldValue("prefisso_segnatura", e.target.value.toUpperCase())
                    setCurrentPrefisso(e.target.value.toUpperCase())
                  }}
                  name="prefisso_segnatura"
                  error={!!errors.prefisso_segnatura}
                  // helperText={errors.segnatura}
                  label={t("fondo.prefisso_segnatura")}
                  size="small"
                  // value={values?.segnatura}
                  margin="dense"
                  fullWidth
                  variant={item && item.has_supporti ? "filled" : "outlined"}
                  disabled={item && item.has_supporti}
                  slotProps={{
                    input: {
                      readOnly: item && item.has_supporti,
                    },
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="segnatura"
                  error={!!errors.segnatura}
                  // helperText={errors.segnatura}
                  helperText={t("fondo.segnatura_helper")}
                  label={t("fondo.segnatura")}
                  size="small"
                  // value={values?.segnatura}
                  value={segnaturaUi}
                  margin="dense"
                  fullWidth
                  variant="filled"
                  disabled
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
              </Grid>

              <Grid size={6}>
                <ACDonatore
                  label={t("fondo.donatore")}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.donatore as number}
                  onChange={(value) => {
                    setFieldValue("donatore", value)
                  }}
                  FormComponent={DonatoreForm}
                  create={createDonatore}
                  initialCreate={(search) => ({ cognome: search })}
                />
              </Grid>
              <Grid size={6}>
                {/* <Field
                  name="tipo_supporto"
                  label={t("fondo.tipo_supporto")}
                  component={FormikSelectVocabolario}
                  vocabolario="fondo_tipo_supporto"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                /> */}
                <ACVocabolarioMulti
                  label={t("fondo.tipo_supporto")}
                  vocabolario="fondo_tipo_supporto"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.tipi_supporto as number[]}
                  onChange={(value) => {
                    setFieldValue("tipi_supporto", value)
                  }}
                  onBlur={() => {
                    setFieldTouched("tipi_supporto", true)
                  }}
                />
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="descrizione_it"
                    label={t("fondo.descrizione")}
                    autoFocus
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="descrizione_en"
                    label={t("fondo.descrizione_en")}
                    autoFocus
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={6}>
                <ACEnte
                  label={t("fondo.conservatore_originale")}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.conservatore_originale}
                  onChange={(value) => {
                    setFieldValue("conservatore_originale", value)
                  }}
                  FormComponent={EnteForm}
                  create={createEnte}
                  initialCreate={(search) => ({ nome: search })}
                />
              </Grid>

              <Grid size={6}>
                <ACEnte
                  label={t("fondo.conservatore_digitale")}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.conservatore_digitale}
                  onChange={(value) => {
                    setFieldValue("conservatore_digitale", value)
                  }}
                  FormComponent={EnteForm}
                  create={createEnte}
                  initialCreate={(search) => ({ nome: search })}
                />
              </Grid>

              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  name="collocazione"
                  label={t("fondo.collocazione")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  name="collocazione_temporanea"
                  label={t("fondo.collocazione_temporanea")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  type="number"
                  name="cronologia_da"
                  label={t("fondo.cronologia_da")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={6}>
                <Field
                  component={FormikTextField}
                  type="number"
                  name="cronologia_a"
                  label={t("fondo.cronologia_a")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="cronologia_note_it"
                    margin="dense"
                    label={t("fondo.cronologia_note")}
                    fullWidth
                    multiline
                    minRows={6}
                    variant="outlined"
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="cronologia_note_en"
                    margin="dense"
                    label={t("fondo.cronologia_note")}
                    fullWidth
                    multiline
                    minRows={6}
                    variant="outlined"
                  />
                )}
              </Grid>

              {/* <Grid size={6}>
                <ACVocabolario
                  label={t("fondo.provenienza")}
                  vocabolario="fondo_provenienza"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.provenienza}
                  onChange={(value) => {
                    setFieldValue("provenienza", value)
                  }}
                  FormComponent={VocaboloForm}
                  create={createVocabolario}
                  initialCreate={(search) => ({ termine_it: search, vocabolario: "fondo_provenienza" })}
                />
              </Grid> */}

              <Grid size={12}>
                <ACLuogoMulti
                  label={t("fondo.provenienza")}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={values.luoghi_provenienza || []}
                  onChange={(value) => {
                    setFieldValue("luoghi_provenienza", value)
                  }}
                  FormComponent={LuogoForm}
                  create={createLuogo}
                  initialCreate={(search) => ({ nome: search })}
                />
              </Grid>

              <Grid size={12}>
                <FondiCollegatiField name="fondi_collegati_data" label={t("fondo.fondi_collegati")} />
              </Grid>

              <Grid size={4} sx={{ ml: 2, mt: 1 }}>
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={values.notifica}
                      onChange={(e) => setFieldValue("notifica", e.target.checked)}
                    />
                  }
                  label={t("fondo.notifica")}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
